<template>
    <el-form label-position="right" size="mini" label-width="130px">
        <el-form-item label="作业指导书说明">
            <el-input
                type="textarea"
                :rows="10"
                placeholder="请输入内容"
                v-model="wiFileInfo.instructions">
            </el-input>
        </el-form-item>
       <el-form-item label="作业指导书附件">
            <FileUpload
                :fileList="wiFileInfo.fileList"
                @success="handleSetFile"
                @remove="handleSetFile"
                @previewFile="previewFile"
                @publicLiberyChoosedSuccess="publicLiberyChoosedSuccess"
                :isShowUploadBtn="isShowUploadBtn"
                :isChoosePublicFiles="true"
            />
        </el-form-item>
    </el-form>
</template>

<script>
    import { cloneDeep } from 'lodash';
    export default {
        data () {
            return {
                // fileList: [],
                //  timeDefaultShow: this.getAfter7Day()
            };
        },
        computed: {
            wiFiles: {
                set (newVal, oldVal) {
                    // this.formData[this.field.formField] = newVal;
                    // console.log(newVal);
                    this.wiFileInfo.fileList = newVal;
                    // let viewArr = newVal;
                    // let viewData =[];
                    // for ( var i = 0; i <viewArr.length; i++){
                    //     viewData.push(viewArr[i].fileName);
                    // }
                    // // console.log(viewData.join(','));
                    // this.formData[this.field.formField+"-view"]=viewData.join(','); // 针对选项、下拉进行名称赋值(多选)
                },
                get (val) {
                    // return this.formData[this.field.formField];
                    return val;
                }
            }
        },
        props: {
            wiFileInfo: {
                type: Object,
                default: function () {
                    return {
                        fileList: [],
                        instructions: ''
                    };
                }
            },
            isShowUploadBtn: {
                type: Boolean,
                default: true
            }
        },
        methods: {
            handleSetFile (params) {
                // let fileObjectKeys = ['name', 'fileName', 'fileByteSize', 'filePath'];
                let fileValues = [];
                try {
                    if (params && params.fileList) {
                        let fileLists = cloneDeep(params.fileList);
                        fileLists.forEach(file => {
                            // console.log(file);
                            if (file.status && file.status === 'success') {
                                if (file.response && file.response.data) {
                                // 本次上传的文件
                                    let resDataList = cloneDeep(file.response.data);
                                    resDataList.forEach(resFile => {
                                        // fileValues.push({
                                        //     name: resFile.fileName,
                                        //     fileName: resFile.fileName,
                                        //     fileByteSize: resFile.fileByteSize,
                                        //     filePath: resFile.filePath
                                        // });
                                        fileValues.push(this.setFileInfo(resFile));
                                    });
                                } else {
                                    fileValues.push(this.setFileInfo(file));
                                }
                            } else {
                                // 以前上传完成，并保存的文件
                                fileValues.push(this.setFileInfo(file));
                            }
                        });
                    }
                    this.wiFiles = fileValues;
                } catch (error) {
                    console.error(error);
                }
            },
            setFileInfo (obj) {
                return {
                    name: obj.fileName,
                    fileName: obj.fileName,
                    fileByteSize: obj.fileByteSize,
                    filePath: obj.filePath
                };
            },
            previewFile (file) {
                this.$emit('previewFile', file);
            },
            publicLiberyChoosedSuccess (resDataList, allFileList) {
                if (resDataList && resDataList.length > 0) {
                    let fileList = cloneDeep(allFileList);
                    resDataList.forEach(file => {
                        fileList.push(this.setFileInfo(file));
                    });
                    this.wiFiles = fileList;
                }
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/pages/process/ProcessEditor/components/WorkInstruction.vue